import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import NoDataImage from '../../assets/images/No-Data.png'
import { Promotion } from '../../graphql/promotions'
import { getTranslate } from '../../localization'
import PromotionRow from './PromotionRow'
import PromotionRowSkeleton from './PromotionRow.skeleton'
import useStyles from './styles/PromotionsTable.styles'

interface PromotionsTableProps {
  data: Promotion[]
  loading: boolean
  reloadData: () => void
}

export const PromotionsTable: React.FC<PromotionsTableProps> = ({
  data,
  loading,
  reloadData
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Provider')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Status')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Discount')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Updated')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            aria-label={getTranslate('Refresh')}
            onClick={() => reloadData()}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading ? (
        Array(5)
          .fill('')
          .map((item, index) => (
            <PromotionRowSkeleton
              key={`promotion-skeleton${index.toString()}`}
            />
          ))
      ) : data.length > 0 ? (
        data.map((promotion) => (
          <Fade in timeout={600} key={promotion.id}>
            <div data-cy="tableRowPromotionData">
              <PromotionRow data={promotion} refetch={reloadData} />
            </div>
          </Fade>
        ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt={getTranslate('No promotions')} />
        </div>
      )}
    </div>
  )
}
